export default "__VITE_ASSET__D8UP2PfB__"